import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

@Directive({
    selector: '[shTabFocusDisable]',
    standalone: true
})
export class ShTabFocusDisableDirective implements AfterViewInit, OnDestroy {
    private observer: MutationObserver;

    constructor(private readonly el: ElementRef) {}

    ngAfterViewInit() {
        this.disableTabOnNodeChildren(this.el.nativeElement);

        this.observer = new MutationObserver(mutations => {
            for (const mutation of mutations) {
                mutation.addedNodes.forEach(node => {
                    if (node instanceof HTMLElement) {
                        this.disableTabOnNodeChildren(node);
                    }
                });
            }
        });

        this.observer.observe(this.el.nativeElement, {
            childList: true,
            subtree: true
        });
    }

    private disableTabOnNodeChildren(root: HTMLElement) {
        const focusables = root.querySelectorAll('input[type="checkbox"]:not([tabindex="-1"])');
        focusables.forEach(el => {
            (el as HTMLElement).setAttribute('tabindex', '-1');
        });
    }

    ngOnDestroy() {
        this.observer?.disconnect();
    }
}
